var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TTooltip',{class:`
    workbench-workpackage-tab
    ${_vm.disabled ? 'disabled-tab': '' }
    ${_vm.selected?`tab-selected ${_vm.color} ${_vm.color.includes('lighten') || _vm.color.includes('darken')? '':'lighten-1'}`:'tab-non-selected'}
    `,style:(`width: ${_vm.width};${_vm.disabled ? 'cursor: default;': 'cursor: pointer;' }`),attrs:{"value":_vm.getToolTip()}},[_c('TIcon',{attrs:{"name":_vm.tab.icon,"color":_vm.text_color}}),(_vm.selected && _vm.tab.text)?_c('div',[_vm._v(_vm._s(_vm.tab.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }